import { useContext } from "react";
import { AnalyticsContext } from "src/apps/providers/AnalyticsContext";

export enum AnalyticsEvents {
  DOCUMENTATION_AREA_FILES_UPLOADED = "documentation_area_files_uploaded",
  DOCUMENTATION_AREA_LOGGED_OUT = "documentation_area_logged_out",
  DOCUMENTATION_AREA_LOCALE_CHANGED = "documentation_area_locale_changed",
  DOCUMENTATION_AREA_OPEN_ADMIN_CLICKED = "documentation_area_open_admin_clicked",
  DOCUMENTATION_AREA_HOME_PAGE_OPENED = "documentation_area_home_page_opened",
  DOCUMENTATION_AREA_LOGIN_SCREEN_OPENED = "documentation_area_login_screen_opened",
  DOCUMENTATION_AREA_OTP_SCREEN_OPENED = "documentation_area_otp_screen_opened",
  DOCUMENTATION_AREA_OTP_SCREEN_CORRECT = "documentation_area_otp_screen_correct",
  DOCUMENTATION_AREA_OTP_SCREEN_ERROR = "documentation_area_otp_screen_error",
  DOCUMENTATION_AREA_OTP_SCREEN_RESEND_CODE = "documentation_area_otp_screen_resend_code",
  DOCUMENTATION_AREA_CONSENTS_SCREEN_OPENED = "documentation_area_consents_screen_opened",
  DOCUMENTATION_AREA_TWO_FACTOR_RESENT = "documentation_area_two_factor_resent",
  DOCUMENTATION_AREA_LOGIN_SCREEN_CORRECT_EMAIL_ENTERED = "documentation_area_login_screen_correct_email_entered",
  DOCUMENTATION_AREA_TWO_FACTOR_SCREEN_EDIT_EMAIL_BUTTON_PRESSED = "documentation_area_two_factor_screen_edit_email_button_pressed",
  DOCUMENTATION_AREA_OPEN_ADMIN_IDV_CLICKED = "documentation_area_open_admin_idv_clicked",
  DOCUMENTATION_AREA_MANUAL_IDV_CLICKED = "documentation_area_manual_idv_clicked",
  DOCUMENTATION_AREA_ACTOR_UPDATED_FROM_TEMPLATE = "documentation_area_actor_updated_from_template",
  DOCUMENTATION_AREA_ACTOR_TEMPLATE_CHANGE_ERROR = "documentation_area_actor_template_change_error",
}

export type AnalyticsProperties = { [key: string]: string | number | boolean };

export const useSendAnalyticEvent = () => {
  const { sendEvent } = useContext(AnalyticsContext);
  return { sendEvent };
};
